import { ToastContainer } from "react-toastify";
import { CircularGrid, InfinityIcon, SearchSmall, BlueEye, Filter, Employee, Active } from "../AllSvg";
import React, { useEffect, useState } from "react";
import usePermission from "../../config/permissions";
import { AddAgeRangeTaxslab, AddInvestmentType, AddEmpInvestmentForm, UpdateEmpInvestmentForm1, AddSurchargeslab, AddTaxregime, AddTaxSection, AddTaxslab, DeleteAgeRangeTaxslab, DeleteInvestmentForm, DeleteInvestmentType, DeleteSurchargeslab, DeleteTaxRegime, DeleteTaxSection, DeleteTaxslab, ResubmitInvestmentDeclaration, ResubmitInvestmentProof, SubmitInvestmentDeclaration, SubmitInvestmentProofs, UpdateAgeRangeTaxslab, UpdateInvestmentType, UpdateSurchargeslab, UpdateTaxregime, UpdateTaxSection, UpdateTaxslab } from "./InvestmentDeclarationComponents";
import { AttachmentIcon, CustomImageModal, formatCurrencyIndian, handleErrorToast, ViewDynamicApprovalRemarks, ViewDynamicApprovalStatus, customSortByKey, UserProfileModal, CustomTooltip } from "../CustomFunctions";
import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../../config/axios";
import { formatDate, formatDateTime, formattedDateLong } from "../Date";
import UserDefaultLogo from "../UserDetails/UserDefaultLogo";
import CustomShowTableData from "../CustomTable/CustomShowTableData";
import ProofViewModal from "../CustomTable/ProofViewModal";
import ProofUploadModal from "../CustomTable/ProofUploadModal";
import Select from "react-select";
import { CSSForDropdownFilter2 } from "../CustomUtilities"

const TaxRegimeTable = () => {

    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
    const [buffer, setBuffering] = useState(true);
    const [taxRegime, setTaxRegime] = useState([]);
    const [searchByName, setSearchByName] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    const getTaxRegime = async () => {
        setBuffering(true);
        try {
            const fetchTaxRegime = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${toggleCompany}/`);
            setTaxRegime(fetchTaxRegime.data);
            setFilteredData(fetchTaxRegime.data);
        } catch (error) {
            handleErrorToast(error);
        } finally {
            setBuffering(false);
        }
    }

    useEffect(() => {
        getTaxRegime()
    }, [toggleCompany])


    const handleSearch = () => {

        let filteredData = taxRegime;

        if (searchByName) {
            const lowercaseSelectedName = searchByName.toLowerCase();
            filteredData = filteredData.filter((n) => {
                const nameMatch = n.name
                    .toLowerCase()
                    .includes(lowercaseSelectedName);

                return (
                    nameMatch
                );
            });
        }


        setFilteredData(filteredData);
    };

    useEffect(() => {
        handleSearch();
    }, [
        searchByName,
    ]);



    return (
        <div className="table-css-white-background">
            <div className="table-heading-flex">
                <div className="repo-heading font-weight500 font-size-heading">Tax Regime</div>
                <div className="field-cont">
                    {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div" style={{ marginRight: '5px' }}>
                        <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                            <option value="null">Select Sub Company</option>
                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

                        </select>
                    </div> : null
                    }
                    <div className="table-searchh field-cont-div">
                        <div>
                            <SearchSmall />
                        </div>
                        <div>
                            <input
                                placeholder="Search name"
                                type="text"
                                className="navbar-inputt font-weight400  font-size-text"
                                value={searchByName}
                                onChange={(e) => setSearchByName(e.target.value)}
                            />
                        </div>
                    </div>
                    <AddTaxregime SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} getTaxRegime={getTaxRegime} />

                </div>
            </div>

            <table className="table-css">
                <thead>
                    <tr className="custom-table-head-tr">
                        <th className="align-left">S.No</th>
                        {toggleCompany === "null" && <th className="align-center">Subcompany</th>}
                        <th className="align-center">Name</th>
                        <th className="align-center">Financial Year</th>
                        <th className="align-center">Proof Submission Period</th>
                        <th className="align-center">Adjustment Period</th>
                        <th className="align-center">Standard Deduction (₹) </th>
                        <th className="align-center">Cess (%)</th>
                        <th className="align-center">Rebate Threshold (₹)</th>
                        <th className="align-center">Total Tax regime usage count</th>
                        <th className="align-center">Created At</th>
                        <th className="align-center">Last Update</th>
                        <th className="align-center">Action</th>
                    </tr>
                </thead>


                {buffer ? <div className="spinner"></div> :

                    <tbody>
                        {[...filteredData]
                            .sort((a, b) => {

                                const startYearA = parseInt(a.financial_year_start?.split('-')[0]) || new Date(a.financial_year_start).getFullYear();
                                const startYearB = parseInt(b.financial_year_start?.split('-')[0]) || new Date(b.financial_year_start).getFullYear();

                                return startYearB - startYearA;
                            })

                            .map((i, index) => (
                                <React.Fragment key={index}>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="6"></td>
                                    </tr>
                                    <tr className="custom-table-head-td">

                                        <td className="align-left">{index + 1}</td>
                                        {toggleCompany === "null" && (
                                            <td className="align-center">{i?.sub_company_title}</td>
                                        )}
                                        <td className="align-center">{i?.name}</td>
                                        <td
                                            style={{ cursor: 'help' }}
                                            title={`${formatDate(i?.financial_year_start)} to ${formatDate(i?.financial_year_end)}`}
                                            className="align-center"
                                        >
                                            {formatDate(i?.financial_year_start, true).MonthYear} to {formatDate(i?.financial_year_end, true).MonthYear}
                                        </td>
                                        <td className="align-center">{formatDate(i?.proof_submission_start_date)} to {formatDate(i?.proof_submission_end_date)}</td>
                                        <td
                                            style={{ cursor: 'help' }}
                                            title={`${formatDate(i?.adjustment_month_start)} to ${formatDate(i?.adjustment_month_end)}`}
                                            className="align-center"
                                        >
                                            {formatDate(i?.adjustment_month_start, true).MonthYear} to {formatDate(i?.adjustment_month_end, true).MonthYear}
                                        </td>
                                        <td className="align-center">
                                            {formatCurrencyIndian(
                                                i?.standard_deduction || 0
                                            )}
                                        </td>
                                        <td className="align-center">{formatCurrencyIndian(i?.cess_percent)}</td>
                                        <td className="align-center">
                                            {formatCurrencyIndian(i?.rebate_threshold || 0)}
                                        </td>

                                        <td className="align-center">
                                            <CustomTooltip
                                                position="top"
                                                tooltipContent={
                                                    <div>
                                                        <div>Investment/Income Types: <strong>{i?.regime_income_investment_count}</strong></div>
                                                        <div>Tax Sections: <strong>{i?.regime_tax_section_count}</strong></div>
                                                        <div>Age Ranges: <strong>{i?.regime_age_range_count}</strong></div>
                                                        <div>Tax Slabs: <strong>{i?.regime_slab_count}</strong></div>
                                                        <div>Surcharge slabs: <strong>{i?.regime_surcharge_count}</strong></div>
                                                        <div>Investment Forms: <strong>{i?.regime_investment_forms_count}</strong></div>
                                                        <div>Saved TDS Details: <strong>{i?.regime_saved_tds_count}</strong></div>
                                                    </div>
                                                }
                                            >
                                                <span style={{ cursor: 'pointer', textDecoration: 'underline', color: '#007bff' }}>
                                                    {i?.total_regime_usage_count}
                                                </span>
                                            </CustomTooltip>
                                        </td>

                                        <td className="table-body align-center">
                                            {i.created_at ? (
                                                <UserProfileModal
                                                    code={i.created_by}
                                                    name={i.created_by_name}
                                                    profilePic={i.created_by_profilepic}
                                                    dateText={formatDateTime(i.created_at).shortfull}
                                                />
                                            )
                                                :
                                                <>
                                                    {formatDateTime(i?.created_at).longdate}
                                                    <br />
                                                    <small>{formatDateTime(i?.created_at).time}</small>
                                                </>
                                            }
                                        </td>

                                        <td className="table-body align-center">

                                            {i.updated_by ? (
                                                <UserProfileModal
                                                    code={i.updated_by}
                                                    name={i.updated_by_name}
                                                    profilePic={i.updated_by_profilepic}
                                                    dateText={formatDateTime(i.updated_at).shortfull}
                                                />
                                            ) : (
                                                <>
                                                    {formatDateTime(i.updated_at).longdate}
                                                    <br />
                                                    <small>{formatDateTime(i.updated_at).time}</small>
                                                </>
                                            )}
                                        </td>


                                        <td className="align-center" >
                                            <div className="flex-row">
                                                <UpdateTaxregime i={i} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} getTaxRegime={getTaxRegime} />
                                                {i?.total_regime_usage_count === 0 &&
                                                    <DeleteTaxRegime i={i} getTaxRegime={getTaxRegime} />
                                                }
                                            </div>
                                        </td>
                                    </tr>

                                </React.Fragment>
                            ))}
                    </tbody>
                }

            </table>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
    );
};

const InvestmentTypesTable = () => {

    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const { SUB_COMPANIES, SUPER_ADMIN, PERMISSION_AUTHORITY } = usePermission();
    const [buffer, setBuffering] = useState(true);
    const [investmentTypes, setInvestmentTypes] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredData, setFilteredData] = useState([]);



    const getInvestmentTypes = async () => {
        setBuffering(true);
        try {
            const fetchInvestmentTypes = await axios.get(`${BASE_URL}/wfm/type-of-investment-by-subcompany/${toggleCompany}/`);
            setInvestmentTypes(fetchInvestmentTypes.data);
            setFilteredData(fetchInvestmentTypes.data);
        } catch (error) {
            handleErrorToast(error);
        } finally {
            setBuffering(false);
        }
    }



    useEffect(() => {
        getInvestmentTypes()
    }, [toggleCompany])


    const handleSearch = () => {

        let filteredData = investmentTypes;

        if (searchQuery) {
            const lowercaseSelectedName = searchQuery.toLowerCase();
            filteredData = filteredData.filter((n) => {
                const nameMatch = n.name
                    .toLowerCase()
                    .includes(lowercaseSelectedName);
                const categoryMatch = n.category
                    .toLowerCase()
                    .includes(lowercaseSelectedName);


                return (
                    nameMatch || categoryMatch
                );
            });
        }



        setFilteredData(filteredData);
    };

    useEffect(() => {
        handleSearch();
    }, [
        searchQuery
    ]);

    return (
        <div className="table-css-white-background">
            <div className="table-heading-flex">
                <div className="repo-heading font-weight500 font-size-heading">Investment / Income Type</div>
                <div className="field-cont">
                    {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div" style={{ marginRight: '5px' }}>
                        <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading">
                            <option value="null">Select Sub Company</option>
                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

                        </select>
                    </div> : null
                    }



                    <div className="table-searchh field-cont-div">
                        <div>
                            <SearchSmall />
                        </div>
                        <div>
                            <input
                                type="text"
                                placeholder="Search by name/category"
                                className="navbar-inputt font-weight400  font-size-text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                    </div>
                    <AddInvestmentType SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} getInvestmentTypes={getInvestmentTypes} />

                </div>
            </div>
            {/* <SectorsDetailForm /> */}
            <table className="table-css">
                <thead>
                    <tr className="custom-table-head-tr">
                        <th className="align-left">S.No</th>
                        {toggleCompany === "null" && <th className="align-center">Subcompany</th>}
                        <th className="align-center">Name</th>
                        <th className="align-center">Category</th>
                        <th className="align-center">Tax Regime</th>
                        <th className="align-center">Total Invest/Income usage count</th>
                        <th className="align-center">Created At</th>
                        <th className="align-center">Last Update</th>
                        <th className="align-center">Action</th>
                    </tr>
                </thead>


                {buffer ? <div className="spinner"></div> :
                    <tbody>
                        {[...filteredData]
                            .sort((a, b) => {
                                const yearA = new Date(a?.regime_details?.financial_year_start);
                                const yearB = new Date(b?.regime_details?.financial_year_start);
                                return yearB - yearA;
                            })
                            .map((i, index) => (
                                <React.Fragment key={index}>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="6"></td>
                                    </tr>
                                    <tr className="custom-table-head-td">
                                        <td className="align-left">{index + 1}</td>
                                        {toggleCompany === "null" && (
                                            <td className="align-center">{i?.sub_company_title}</td>
                                        )}
                                        <td className="align-center text-capitalize">{i?.name}</td>
                                        <td className="align-center text-capitalize">{i?.category}</td>
                                        <td className="align-center">{i?.regime_details?.name} ({formattedDateLong(i?.regime_details?.financial_year_start)} - {formattedDateLong(i?.regime_details?.financial_year_end)})</td>

                                        <td className="align-center">
                                            <CustomTooltip
                                                position="top"
                                                tooltipContent={
                                                    <div>
                                                        <div>Tax section: <strong>{i?.invest_income_tax_section_count}</strong></div>
                                                    </div>
                                                }
                                            >
                                                <span style={{ cursor: 'pointer', textDecoration: 'underline', color: '#007bff' }}>
                                                    {i?.total_invest_income_usage_count}
                                                </span>
                                            </CustomTooltip>
                                        </td>
                                        <td className="table-body align-center">
                                            {i.created_at ? (
                                                <UserProfileModal
                                                    code={i.created_by}
                                                    name={i.created_by_name}
                                                    profilePic={i.created_by_profilepic}
                                                    dateText={formatDateTime(i.created_at).shortfull}
                                                />
                                            )
                                                :
                                                <>
                                                    {formatDateTime(i?.created_at).longdate}
                                                    <br />
                                                    <small>{formatDateTime(i?.created_at).time}</small>
                                                </>
                                            }
                                        </td>


                                        <td className="table-body align-center">

                                            {i.updated_by ? (
                                                <UserProfileModal
                                                    code={i.updated_by}
                                                    name={i.updated_by_name}
                                                    profilePic={i.updated_by_profilepic}
                                                    dateText={formatDateTime(i.updated_at).shortfull}
                                                />
                                            ) : (
                                                <>
                                                    {formatDateTime(i.updated_at).longdate}
                                                    <br />
                                                    <small>{formatDateTime(i.updated_at).time}</small>
                                                </>
                                            )}
                                        </td>
                                        <td className="align-center" >
                                            {/* <div className="flex-row"> */}
                                            <UpdateInvestmentType i={i} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} getInvestmentTypes={getInvestmentTypes} />
                                            {i?.total_invest_income_usage_count === 0 && <DeleteInvestmentType i={i} getInvestmentTypes={getInvestmentTypes} />}

                                            {/* </div> */}
                                        </td>
                                    </tr>

                                </React.Fragment>
                            ))}
                    </tbody>
                }

            </table>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
    );
};

const TaxSectionTable = () => {

    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const { SUB_COMPANIES, SUPER_ADMIN, PERMISSION_AUTHORITY } = usePermission();
    const [buffer, setBuffering] = useState(true);
    const [buffer1, setBuffering1] = useState(true);
    const [taxSection, setTaxSection] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [taxRegimeData, setTaxRegimeData] = useState([]);
    const [regimeList, setTaxRegimeList] = useState("");


    const getTaxSection = async (companyId = toggleCompany, regime = regimeList) => {
        setBuffering(true);
        try {
            const regimeParam = regime ? regime : "null";
            const res = await axios.get(
                `${BASE_URL}/wfm/tax-sections-by-subcompany-tax-regime/${companyId}/${regimeParam}/`
            );
            setTaxSection(res.data);
            setFilteredData(res.data);
        } catch (error) {
            handleErrorToast(error);
        } finally {
            setBuffering(false);
        }
    };


    const getTaxRegimeList = async (companyId) => {
        setBuffering1(true);
        if (!companyId || companyId === "null") {
            setTaxRegimeData([]);
            // setTaxRegimeList("null");
            return;
        }
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${companyId}/`);
            setTaxRegimeData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false)
        }
    };

    useEffect(() => {
        if (toggleCompany) {
            getTaxRegimeList(toggleCompany);
            getTaxSection(toggleCompany, regimeList);
        }
    }, [toggleCompany, regimeList]);



    const handleSearch = () => {
        let filteredData = taxSection;


        if (searchQuery) {
            const text = searchQuery.toLowerCase();

            filteredData = filteredData.filter((n) => {
                const codeMatch = n.code?.toLowerCase().includes(text);
                const descMatch = n.description?.toLowerCase().includes(text);
                const typeMatch = n.type_details?.type?.toLowerCase().includes(text);
                // const regimeMatch = n.regime_details?.name?.toLowerCase().includes(text);
                return codeMatch || descMatch || typeMatch
                // || regimeMatch;
            });
        }

        if (regimeList) {
            filteredData = filteredData.filter((n) => {
                return String(n?.name) === regimeList;
            });
        }


        setFilteredData(filteredData);
    };




    useEffect(() => {
        handleSearch();
    }, [
        searchQuery,
        regimeList,

    ]);


    return (
        <div className="table-css-white-background">
            <div className="table-heading-flex">
                <div className="repo-heading font-weight500 font-size-heading">Tax Section</div>
                <div className="field-cont">
                    {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div" style={{ marginRight: '5px' }}>
                        <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                            <option value="null">Select Sub Company</option>
                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

                        </select>
                    </div> : null
                    }

                    <div className="field-cont-div">
                        <div className="table-searchh color-badge-white">
                            <div className="field-cont-div">
                                {buffer1 ? <div className="spinner-vsmall"></div> : <Filter />}

                                <select
                                    className="attendance-input-field width-25vw date-field"

                                    value={regimeList}
                                    onChange={(e) => setTaxRegimeList(e.target.value)}
                                >
                                    <option value="">Select Tax Regime</option>
                                    {taxRegimeData.map((i) => (
                                        <option value={i.id}>
                                            {i.name} ({formattedDateLong(i.financial_year_start)} - {formattedDateLong(i.financial_year_end)})
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <hr className="field-cont-hr" />
                        </div>
                    </div>

                    {/* <hr className="field-cont-hr hr-line-height" /> */}

                    <div className="table-searchh field-cont-div">
                        <div>
                            <SearchSmall />
                        </div>
                        <div>
                            <input
                                type="text"
                                placeholder="Search by Code, Description, Type"
                                className="navbar-inputt font-weight400  font-size-text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                    </div>
                    <AddTaxSection SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} getTaxSections={getTaxSection} />

                </div>
            </div>

            <table className="table-css">
                <thead>
                    <tr className="custom-table-head-tr">
                        <th className="align-left">S.No</th>
                        {toggleCompany === "null" && <th className="align-center">Subcompany</th>}
                        <th className="align-center">Code / Name</th>
                        <th className="align-center">Description</th>
                        <th className="align-center">Category</th>
                        <th className="align-center">Tax Regime</th>
                        <th className="align-center">Max Limit</th>
                        <th className="align-center">Document</th>
                        <th className="align-center">Total Tax section usage count</th>
                        <th className="align-center">Created At</th>
                        <th className="align-center">Last Update</th>
                        <th className="align-center">Action</th>
                    </tr>
                </thead>


                {buffer ? <div className="spinner"></div> :

                    <tbody>
                        {[...filteredData]
                            .sort((a, b) => {
                                const yearA = new Date(a?.regime_details?.financial_year_start);
                                const yearB = new Date(b?.regime_details?.financial_year_start);
                                return yearB - yearA;
                            })
                            .map((i, index) => (
                                <React.Fragment key={index}>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="6"></td>
                                    </tr>
                                    <tr className="custom-table-head-td">
                                        <td className="align-left">{index + 1}</td>
                                        {toggleCompany === "null" && (
                                            <td className="align-center">{i?.sub_company_title}</td>
                                        )}
                                        <td className="align-center">
                                            {i?.code}
                                            {i.is_manual && <button className="priority-button color-tab-blue">Manual</button>}

                                        </td>

                                        <td className="align-center">{i?.description || '-'}</td>
                                        <td className="align-center text-capitalize">{i?.type_details?.type && `${i?.type_details?.type} under ${i?.type_details?.name}`}</td>
                                        <td className="align-center">{i?.regime_details?.name} ({formatDate(i?.regime_details?.financial_year_start)} - {formatDate(i?.regime_details?.financial_year_end)})</td>

                                        <td className="align-center">
                                            {i?.type_details?.type?.toLowerCase() === "investment"
                                                ? (i?.max_limit != null ? formatCurrencyIndian(i.max_limit) : '-')
                                                : '-'}
                                        </td>


                                        <td className="align-center">
                                            {i.ref_doc ?
                                                <a href={i.ref_doc} target="_blank" rel="noreferrer">
                                                    <AttachmentIcon source={i.ref_doc} />
                                                </a>
                                                : '-No File Attached-'}
                                        </td>

                                        <td className="align-center">
                                            <CustomTooltip
                                                position="top"
                                                tooltipContent={
                                                    <div>Investment Forms: <strong>{i?.section_form_count}</strong></div>
                                                }
                                            >
                                                <span style={{ cursor: 'pointer', textDecoration: 'underline', color: '#007bff' }}>
                                                    {i?.total_section_usage_count}
                                                </span>
                                            </CustomTooltip>
                                        </td>
                                        <td className="table-body align-center">
                                            {i.created_at ? (
                                                <UserProfileModal
                                                    code={i.created_by}
                                                    name={i.created_by_name}
                                                    profilePic={i.created_by_profilepic}
                                                    dateText={formatDateTime(i.created_at).shortfull}
                                                />
                                            )
                                                :
                                                <>
                                                    {formatDateTime(i?.created_at).longdate}
                                                    <br />
                                                    <small>{formatDateTime(i?.created_at).time}</small>
                                                </>
                                            }
                                        </td>



                                        <td className="table-body align-center">

                                            {i.updated_by ? (
                                                <UserProfileModal
                                                    code={i.updated_by}
                                                    name={i.updated_by_name}
                                                    profilePic={i.updated_by_profilepic}
                                                    dateText={formatDateTime(i.updated_at).shortfull}
                                                />
                                            ) : (
                                                <>
                                                    {formatDateTime(i.updated_at).longdate}
                                                    <br />
                                                    <small>{formatDateTime(i.updated_at).time}</small>
                                                </>
                                            )}
                                        </td>

                                        <td className="align-center" >
                                            <div className="flex-row ">
                                                <UpdateTaxSection i={i} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} getTaxSections={getTaxSection} />
                                                {i?.total_section_usage_count === 0 && <DeleteTaxSection i={i} getTaxSections={getTaxSection} />}

                                            </div>
                                        </td>
                                    </tr>

                                </React.Fragment>
                            ))}
                    </tbody>
                }

            </table>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
    );
};

const AgeRangeForTaxSlabTable = () => {

    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const { SUB_COMPANIES, SUPER_ADMIN, PERMISSION_AUTHORITY } = usePermission();
    const [buffer, setBuffering] = useState(true);
    const [buffer1, setBuffering1] = useState(true);
    const [ageRangeData, setAgeRangeData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [taxRegimeData, setTaxRegimeData] = useState([]);
    const [regimeList, setTaxRegimeList] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    const getAgeRangeTaxSlab = async (companyId = toggleCompany, regime = regimeList) => {
        setBuffering(true);
        try {
            const regimeParam = regime ? regime : "null";
            const fetchAgeRange = await axios.get(`${BASE_URL}/wfm/age-range-by-subcompany-regime/${companyId}/${regimeParam}/`);
            setAgeRangeData(fetchAgeRange.data);
            setFilteredData(fetchAgeRange.data);
        } catch (error) {
            handleErrorToast(error);
        } finally {
            setBuffering(false);
        }
    }

    const getTaxRegimeList = async (companyId) => {
        setBuffering1(true);
        if (!companyId || companyId === "null") {
            setTaxRegimeData([]);

            return;
        }
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${companyId}/`);
            setTaxRegimeData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false)
        }
    };

    useEffect(() => {
        if (toggleCompany) {
            getTaxRegimeList(toggleCompany);
            getAgeRangeTaxSlab(toggleCompany, regimeList)
        }
    }, [toggleCompany, regimeList])

    const handleSearch = () => {
        let filtered = ageRangeData;

        if (searchQuery) {
            const lowercaseQuery = searchQuery.toLowerCase();

            filtered = filtered.filter((n) => {
                const startMatch = n.age_limit_start
                    ?.toString()
                    .toLowerCase()
                    .includes(lowercaseQuery);
                const endMatch = n.age_limit_end
                    ?.toString()
                    .toLowerCase()
                    .includes(lowercaseQuery);
                const labelMatch = n.lable
                    ?.toLowerCase()
                    .includes(lowercaseQuery);
                const regimeMatch = n.regime_details?.name
                    ?.toLowerCase()
                    .includes(lowercaseQuery);

                return startMatch || endMatch || labelMatch || regimeMatch;
            });
        }

        setFilteredData(filtered);
    };



    useEffect(() => {
        handleSearch();
    }, [searchQuery, ageRangeData]);



    return (
        <div className="table-css-white-background">
            <div className="table-heading-flex">
                <div className="repo-heading font-weight500 font-size-heading">Tax Age Range For Tax Slab</div>
                <div className="field-cont">
                    {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div" style={{ marginRight: '5px' }}>
                        <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                            <option value="null">Select Sub Company</option>
                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

                        </select>
                    </div> : null
                    }


                    <div className="field-cont-div">
                        <div className="table-searchh color-badge-white">
                            <div className="field-cont-div">
                                {buffer1 ? <div className="spinner-vsmall"></div> : <Filter />}

                                <select
                                    className="attendance-input-field width-25vw date-field"
                                    value={regimeList}
                                    onChange={(e) => setTaxRegimeList(e.target.value)}
                                >
                                    <option value="">Select Tax Regime</option>
                                    {taxRegimeData.map((i) => (
                                        <option value={i.id}>
                                            {i.name} ({formattedDateLong(i.financial_year_start)} - {formattedDateLong(i.financial_year_end)})
                                        </option>
                                    ))}
                                </select>

                            </div>
                        </div>
                        <hr className="field-cont-hr" />
                    </div>

                    {/* <hr className="field-cont-hr hr-line-height" /> */}

                    <div className="table-searchh field-cont-div">
                        <div>
                            <SearchSmall />
                        </div>
                        <div>
                            <input
                                placeholder="Search by Age range or Label"
                                className="navbar-inputt font-weight400  font-size-text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}

                            />
                        </div>
                    </div>
                    <AddAgeRangeTaxslab SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} getAgeRangeTaxSlab={getAgeRangeTaxSlab} />

                </div>
            </div>

            <table className="table-css">
                <thead>
                    <tr className="custom-table-head-tr">
                        <th className="align-left">S.No</th>
                        {toggleCompany === "null" && <th className="align-center">Subcompany</th>}
                        <th className="align-center">Lable</th>
                        <th className="align-center">Age Range</th>
                        <th className="align-center">Tax Regime</th>
                        <th className="align-center">Total age range usage count</th>
                        <th className="align-center">Created At</th>
                        <th className="align-center">Last Update</th>
                        <th className="align-center">Action</th>
                    </tr>
                </thead>


                {buffer ? <div className="spinner"></div> :

                    <tbody>
                        {filteredData
                            ?.slice()
                            .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
                            .map((i, index) => (
                                // ?.sort((a, b) => a.created_at - b.created_at).map((i, index) => (
                                <React.Fragment key={index}>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="6"></td>
                                    </tr>
                                    <tr className="custom-table-head-td">
                                        <td className="align-left">{index + 1}</td>
                                        {toggleCompany === "null" && (
                                            <td className="align-center">{i?.sub_company_title}</td>
                                        )}
                                        <td className="align-center">{i?.lable}</td>
                                        {/* <td className="align-center">{i?.age_limit_start}-{i?.age_limit_end === null ? <InfinityIcon /> : i?.age_limit_end} years</td> */}
                                        <td className="align-center">{i?.age_limit_start}{i?.age_limit_end !== null && '-'}{i?.age_limit_end === null ? '+' : i?.age_limit_end} years</td>



                                        <td className="align-center">{i?.regime_details?.name} ({formatDate(i?.regime_details?.financial_year_start)} - {formatDate(i?.regime_details?.financial_year_end)})</td>

                                        <td className="align-center">
                                            <CustomTooltip
                                                position="top"
                                                tooltipContent={
                                                    <div>
                                                        <div>Surcharge slabs: <strong>{i?.agerange_slab_count}</strong></div>
                                                    </div>
                                                }

                                            >
                                                <span style={{ cursor: 'pointer', textDecoration: 'underline', color: '#007bff' }}>
                                                    {i?.total_agerange_usage_count}
                                                </span>
                                            </CustomTooltip>
                                        </td>

                                        <td className="table-body align-center">
                                            {i.created_at ? (
                                                <UserProfileModal
                                                    code={i.created_by}
                                                    name={i.created_by_name}
                                                    profilePic={i.created_by_profilepic}
                                                    dateText={formatDateTime(i.created_at).shortfull}
                                                />
                                            )
                                                :
                                                <>
                                                    {formatDateTime(i?.created_at).longdate}
                                                    <br />
                                                    <small>{formatDateTime(i?.created_at).time}</small>
                                                </>
                                            }
                                        </td>


                                        {/* <td className="table-body align-center">
                                            <>
                                                {i.updated_by &&
                                                    <>
                                                        <CustomImageModal customStyle>
                                                            {i.updated_by_profilepic ? (
                                                                <img
                                                                    src={`${`${IMAGE_URL}${i.updated_by_profilepic}`}`}
                                                                    alt="profile" className="profile-img"
                                                                />
                                                            ) : (
                                                                <UserDefaultLogo user={{ name: i.updated_by_name, profilepic: i.updated_by_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                            )}
                                                        </CustomImageModal>
                                                        <p>{`${i.updated_by} - `}{i.updated_by_name}</p>

                                                    </>
                                                }
                                                {i.updated_by ?
                                                    <small>{i?.updated_at && formatDateTime(i?.updated_at).shortfull}</small>
                                                    :
                                                    <>
                                                        {i?.updated_at && formatDateTime(i?.updated_at).longdate}
                                                        <br />
                                                        <small>{i?.updated_at && formatDateTime(i?.updated_at).time}</small>
                                                    </>}
                                            </>
                                        </td> */}
                                        <td className="table-body align-center">

                                            {i.updated_by ? (
                                                <UserProfileModal
                                                    code={i.updated_by}
                                                    name={i.updated_by_name}
                                                    profilePic={i.updated_by_profilepic}
                                                    dateText={formatDateTime(i.updated_at).shortfull}
                                                />
                                            ) : (
                                                <>
                                                    {formatDateTime(i.updated_at).longdate}
                                                    <br />
                                                    <small>{formatDateTime(i.updated_at).time}</small>
                                                </>
                                            )}
                                        </td>
                                        <td className="align-center" >
                                            <div className="flex-row ">
                                                <UpdateAgeRangeTaxslab i={i} SUPER_ADMIN={SUPER_ADMIN} SUB_COMPANIES={SUB_COMPANIES} getAgeRangeTaxSlab={getAgeRangeTaxSlab} />
                                                {i?.total_agerange_usage_count === 0 && <DeleteAgeRangeTaxslab i={i} getAgeRangeTaxSlab={getAgeRangeTaxSlab} />}

                                            </div>
                                        </td>
                                    </tr>

                                </React.Fragment>
                            ))}
                    </tbody>
                }

            </table>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
    );
};

const TaxSlabTable = () => {

    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const { SUB_COMPANIES, SUPER_ADMIN, PERMISSION_AUTHORITY } = usePermission();
    const [buffer, setBuffering] = useState(true);
    const [buffer1, setBuffering1] = useState(true);
    const [taxSlab, setTaxSlab] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [taxRegimeData, setTaxRegimeData] = useState([]);
    const [regimeList, setTaxRegimeList] = useState("");

    const getTaxSlab = async (companyId = toggleCompany, regime = regimeList) => {
        setBuffering(true);
        try {
            const regimeParam = regime ? regime : "null";
            const fetchTaxSlab = await axios.get(`${BASE_URL}/wfm/tax-slab-filter/${companyId}/${regimeParam}/null/`);
            setTaxSlab(fetchTaxSlab.data);
            setFilteredData(fetchTaxSlab.data);
        } catch (error) {
            handleErrorToast(error);
        } finally {
            setBuffering(false);
        }
    }

    const getTaxRegimeList = async (companyId) => {
        setBuffering1(true);
        if (!companyId || companyId === "null") {
            setTaxRegimeData([]);

            return;
        }
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${companyId}/`);
            setTaxRegimeData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false)
        }
    };

    useEffect(() => {
        if (toggleCompany) {
            getTaxRegimeList(toggleCompany);
            getTaxSlab(toggleCompany, regimeList)
        }
    }, [toggleCompany, regimeList])


    const handleSearch = () => {
        let filtered = taxSlab;

        if (searchQuery) {
            const lowercaseQuery = searchQuery.toLowerCase();

            filtered = filtered.filter((n) => {
                const labelMatch = n.age_range_details?.lable
                    ?.toLowerCase()
                    .includes(lowercaseQuery);
                const startMatch = n.age_range_details?.age_limit_start
                    ?.toString()
                    .toLowerCase()
                    .includes(lowercaseQuery);
                const endMatch = n.age_range_details?.age_limit_end
                    ?.toString()
                    .toLowerCase()
                    .includes(lowercaseQuery);
                const regimeMatch = n.age_range_details?.regime_details?.name
                    ?.toLowerCase()
                    .includes(lowercaseQuery);

                return labelMatch || startMatch || endMatch || regimeMatch;
            });
        }

        setFilteredData(filtered);
    };



    useEffect(() => {
        handleSearch();
    }, [
        searchQuery, taxSlab
    ]);


    return (
        <div className="table-css-white-background">
            <div className="table-heading-flex">
                <div className="repo-heading font-weight500 font-size-heading">Tax Slab</div>
                <div className="field-cont">
                    {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div" style={{ marginRight: '5px' }}>
                        <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                            <option value="null">Select Sub Company</option>
                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

                        </select>
                    </div> : null
                    }


                    <div className="field-cont-div">
                        <div className="table-searchh color-badge-white">
                            <div className="field-cont-div">
                                {buffer1 ? <div className="spinner-vsmall"></div> : <Filter />}

                                <select
                                    className="attendance-input-field width-25vw date-field"
                                    value={regimeList}
                                    onChange={(e) => setTaxRegimeList(e.target.value)}
                                >
                                    <option value="">Select Tax Regime</option>
                                    {taxRegimeData.map((i) => (
                                        <option value={i.id}>
                                            {i.name} ({formattedDateLong(i.financial_year_start)} - {formattedDateLong(i.financial_year_end)})
                                        </option>
                                    ))}
                                </select>

                            </div>
                        </div>
                        <hr className="field-cont-hr" />
                    </div>
                    {/* <hr className="field-cont-hr hr-line-height" /> */}

                    <div className="table-searchh field-cont-div">
                        <div>
                            <SearchSmall />
                        </div>
                        <div>
                            <input
                                placeholder="Search by Age category, Age range, or Tax Regime"

                                className="navbar-inputt font-weight400  font-size-text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}

                            />
                        </div>
                    </div>
                    <AddTaxslab SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} getTaxSlab={getTaxSlab} />

                </div>
            </div>

            <table className="table-css">
                <thead>
                    <tr className="custom-table-head-tr">
                        <th className="align-left">S.No</th>
                        {toggleCompany === "null" && <th className="align-center">Subcompany</th>}
                        <th className="align-center">Age Category</th>
                        <th className="align-center">Age Range</th>
                        <th className="align-center">Limit Range</th>

                        <th className="align-center">Rate(%)</th>
                        <th className="align-center">Tax regime</th>
                        <th className="align-center">Total Tax slabs usage count</th>
                        <th className="align-center">Created At</th>
                        <th className="align-center">Last Update</th>
                        <th className="align-center">Action</th>
                    </tr>
                </thead>


                {buffer ? <div className="spinner"></div> :

                    <tbody>
                        {[...filteredData]
                            .sort((a, b) => {
                                const yearA = new Date(a?.age_range_details?.regime_details?.financial_year_start);
                                const yearB = new Date(b?.age_range_details?.regime_details?.financial_year_start);
                                return yearB - yearA;
                            })
                            .map((i, index) => (
                                <React.Fragment key={index}>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="6"></td>
                                    </tr>
                                    <tr className="custom-table-head-td">
                                        <td className="align-left">{index + 1}</td>
                                        {toggleCompany === "null" && (
                                            <td className="align-center">{i?.sub_company_title}</td>
                                        )}
                                        <td className="align-center">{i?.age_range_details?.lable}</td>
                                        {/* <td className="align-center">{i?.age_range_details?.age_limit_start}-{i?.age_range_details?.age_limit_end === null ? <InfinityIcon /> : i?.age_range_details?.age_limit_end} years</td> */}
                                        <td className="align-center">{i?.age_range_details?.age_limit_start}{i?.age_range_details?.age_limit_end !== null && "-"}{i?.age_range_details?.age_limit_end === null ? "+" : i?.age_range_details?.age_limit_end} years</td>
                                        {/* <td className="align-center">{i?.lower_limit} - {i?.upper_limit}</td> */}
                                        <td className="align-center">{formatCurrencyIndian(i?.lower_limit)} - {formatCurrencyIndian(i?.upper_limit)} </td>
                                        <td className="align-center">{i?.rate}</td>
                                        <td className="align-center">{i?.age_range_details?.regime_details?.name} ({formatDate(i?.age_range_details?.regime_details?.financial_year_start)} to {formatDate(i?.age_range_details?.regime_details?.financial_year_end)})</td>

                                        <td className="align-center">
                                            <CustomTooltip
                                                position="top"
                                                tooltipContent={
                                                    <div>
                                                        <div>Saved TDS: <strong>{i?.slab_regime_saved_tax_count}</strong></div>
                                                    </div>
                                                }

                                            >
                                                <span style={{ cursor: 'pointer', textDecoration: 'underline', color: '#007bff' }}>
                                                    {i?.total_slab_usage_count}
                                                </span>
                                            </CustomTooltip>
                                        </td>
                                        <td className="table-body align-center">
                                            {i.created_at ? (
                                                <UserProfileModal
                                                    code={i.created_by}
                                                    name={i.created_by_name}
                                                    profilePic={i.created_by_profilepic}
                                                    dateText={formatDateTime(i.created_at).shortfull}
                                                />
                                            )
                                                :
                                                <>
                                                    {formatDateTime(i?.created_at).longdate}
                                                    <br />
                                                    <small>{formatDateTime(i?.created_at).time}</small>
                                                </>
                                            }
                                        </td>


                                        <td className="table-body align-center">

                                            {i.updated_by ? (
                                                <UserProfileModal
                                                    code={i.updated_by}
                                                    name={i.updated_by_name}
                                                    profilePic={i.updated_by_profilepic}
                                                    dateText={formatDateTime(i.updated_at).shortfull}
                                                />
                                            ) : (
                                                <>
                                                    {formatDateTime(i.updated_at).longdate}
                                                    <br />
                                                    <small>{formatDateTime(i.updated_at).time}</small>
                                                </>
                                            )}
                                        </td>
                                        <td className="align-center" >
                                            <div className="flex-row ">
                                                <UpdateTaxslab i={i} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} getTaxSlab={getTaxSlab} />
                                                {(SUPER_ADMIN || (i?.total_slab_usage_count === 0)) && <DeleteTaxslab i={i} getTaxSlab={getTaxSlab} />}

                                            </div>
                                        </td>
                                    </tr>

                                </React.Fragment>
                            ))}
                    </tbody>
                }

            </table>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
    );
};

const SurchargeSlabTable = () => {

    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const { SUB_COMPANIES, SUPER_ADMIN, PERMISSION_AUTHORITY } = usePermission();
    const [buffer, setBuffering] = useState(true);
    const [surchargeSlab, setSurchargeSlab] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredData, setFilteredData] = useState([]);


    const getSurchargeSlab = async () => {
        setBuffering(true);
        try {
            const fetchSurchargeSlab = await axios.get(`${BASE_URL}/wfm/surcharge-slab-by-subcompany/${toggleCompany}/`);
            setSurchargeSlab(fetchSurchargeSlab.data);
            setFilteredData(fetchSurchargeSlab.data);
        } catch (error) {
            handleErrorToast(error);
        } finally {
            setBuffering(false);
        }
    }

    useEffect(() => {
        getSurchargeSlab()
    }, [toggleCompany])


    const handleSearch = () => {
        let filtered = surchargeSlab;

        if (searchQuery) {
            const lowercaseQuery = searchQuery.toLowerCase();

            filtered = filtered.filter((n) => {
                const minMatch = n.min_income
                    ?.toString()
                    .toLowerCase()
                    .includes(lowercaseQuery);
                const maxMatch = n.max_income
                    ?.toString()
                    .toLowerCase()
                    .includes(lowercaseQuery);
                const regimeMatch = n.regime_details?.name
                    ?.toLowerCase()
                    .includes(lowercaseQuery);

                return minMatch || maxMatch || regimeMatch;
            });
        }

        setFilteredData(filtered);
    };


    useEffect(() => {
        handleSearch();
    }, [searchQuery, surchargeSlab]);



    return (
        <div className="table-css-white-background">
            <div className="table-heading-flex">
                <div className="repo-heading font-weight500 font-size-heading">Surcharge slab</div>
                <div className="field-cont">
                    {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div" style={{ marginRight: '5px' }}>
                        <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                            <option value="null">Select Sub Company</option>
                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

                        </select>
                    </div> : null
                    }
                    <div className="table-searchh field-cont-div">
                        <div>
                            <SearchSmall />
                        </div>
                        <div>
                            <input
                                placeholder="Search by Min/Max Income or Tax Regime"
                                className="navbar-inputt font-weight400  font-size-text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}

                            />
                        </div>
                    </div>
                    <AddSurchargeslab SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} getSurchargeSlab={getSurchargeSlab} />

                </div>
            </div>

            <table className="table-css">
                <thead>
                    <tr className="custom-table-head-tr">
                        <th className="align-left">S.No</th>
                        {toggleCompany === "null" && <th className="align-center">Subcompany</th>}

                        <th className="align-center">Income Range</th>

                        <th className="align-center">Rate</th>
                        <th className="align-center">Tax regime</th>
                        <th className="align-center">Total Surcharge slabs usage count</th>
                        <th className="align-center">Created At</th>
                        <th className="align-center">Last Update</th>
                        <th className="align-center">Action</th>
                    </tr>
                </thead>


                {buffer ? <div className="spinner"></div> :

                    <tbody>
                        {[...filteredData]
                            .sort((a, b) => {
                                const yearA = new Date(a?.regime_details?.financial_year_start);
                                const yearB = new Date(b?.regime_details?.financial_year_start);
                                return yearB - yearA;
                            })
                            .map((i, index) => (
                                <React.Fragment key={index}>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="6"></td>
                                    </tr>
                                    <tr className="custom-table-head-td">
                                        <td className="align-left">{index + 1}</td>
                                        {toggleCompany === "null" && (
                                            <td className="align-center">{i?.sub_company_title}</td>
                                        )}

                                        <td className="align-center">{formatCurrencyIndian(i?.min_income)} - {formatCurrencyIndian(i?.max_income)}</td>


                                        <td className="align-center">{i?.rate}</td>
                                        <td className="align-center">{i?.regime_details?.name} ({formatDate(i?.regime_details?.financial_year_start)} to {formatDate(i?.regime_details?.financial_year_end)})</td>
                                        <td className="align-center">
                                            <CustomTooltip
                                                position="top"
                                                tooltipContent={
                                                    <div>
                                                        <div>Saved TDS: <strong>{i?.surchargeslab_regime_saved_tax_count}</strong></div>
                                                    </div>
                                                }

                                            >
                                                <span style={{ cursor: 'pointer', textDecoration: 'underline', color: '#007bff' }}>
                                                    {i?.total_surchargeslab_usage_count}
                                                </span>
                                            </CustomTooltip>
                                        </td>
                                        <td className="table-body align-center">
                                            {i.created_at ? (
                                                <UserProfileModal
                                                    code={i.created_by}
                                                    name={i.created_by_name}
                                                    profilePic={i.created_by_profilepic}
                                                    dateText={formatDateTime(i.created_at).shortfull}
                                                />
                                            )
                                                :
                                                <>
                                                    {formatDateTime(i?.created_at).longdate}
                                                    <br />
                                                    <small>{formatDateTime(i?.created_at).time}</small>
                                                </>
                                            }
                                        </td>


                                        <td className="table-body align-center">

                                            {i.updated_by ? (
                                                <UserProfileModal
                                                    code={i.updated_by}
                                                    name={i.updated_by_name}
                                                    profilePic={i.updated_by_profilepic}
                                                    dateText={formatDateTime(i.updated_at).shortfull}
                                                />
                                            ) : (
                                                <>
                                                    {formatDateTime(i.updated_at).longdate}
                                                    <br />
                                                    <small>{formatDateTime(i.updated_at).time}</small>
                                                </>
                                            )}
                                        </td>

                                        <td className="align-center" >
                                            <div className="flex-row ">
                                                <UpdateSurchargeslab i={i} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} getSurchargeSlab={getSurchargeSlab} />
                                                {SUPER_ADMIN || (i?.total_surchargeslab_usage_count === 0) &&
                                                    <DeleteSurchargeslab i={i} getSurchargeSlab={getSurchargeSlab} />
                                                }
                                            </div>
                                        </td>
                                    </tr>

                                </React.Fragment>
                            ))}
                    </tbody>
                }

            </table>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
    );
};

const InvestmentDeclarationFormTable = ({ email, emp_code, viewAccess }) => {

    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const { SUB_COMPANIES, SUPER_ADMIN, PERMISSION_AUTHORITY, PERMISSION_HR_ADMIN } = usePermission();
    const [buffer, setBuffering] = useState(true);
    const [investmentFormData, setInvestmentFormData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    const [declarationStatus, setDeclarationStatus] = useState('null')
    const [proofStatus, setProofStatus] = useState('null')
    const [buffer1, setBuffering1] = useState(true);
    const [viewProof, setViewProof] = useState(false);
    const [selectedProofs, setSelectedProofs] = useState([]);
    const [calculationProofData, setCalculationProofData] = useState(null);
    const [uploadProof, setUploadProof] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [division, setDivision] = useState(sessionStorage.getItem('company_id') || 'null');
    const [empList, setEmpList] = useState([])
    const [active, setActive] = useState("active");
    const [employee, setEmployee] = useState(emp_code || 'null');
    const [buffer2, setBuffering2] = useState(true);
    const [taxRegimeData, setTaxRegimeData] = useState([]);
    const [regimeList, setTaxRegimeList] = useState("");
    const [declarationFilter, setDeclarationFilter] = useState("");
    const [proofFilter, setProofFilter] = useState("");
    const [currentFormExists, setCurrentFormExist] = useState(false);


    const getUserInvestmentDetails = async () => {
        setBuffering(true);
        try {
            // const fetchInvestmentForm = await axios.get(`${BASE_URL}/wfm/investment-form-by-subcompany/${res.data.division}/`);
            const fetchInvestmentForm = await axios.get(
                `${BASE_URL}/wfm/investment-form-bysubcompany-byempstatus-byemployee-byformstatus-byproofstatus/${division}/null/${emp_code || 'null'}/${declarationStatus}/${proofStatus}/`
            );
            setInvestmentFormData(fetchInvestmentForm.data);
            setFilteredData(fetchInvestmentForm.data);
            const today = new Date();

            const isCurrentFormExist = fetchInvestmentForm.data.some((form) => {
                const startDate = new Date(form.regime_details.financial_year_start);
                const endDate = new Date(form.regime_details.financial_year_end);

                return startDate <= today && today <= endDate;
            });
            setCurrentFormExist(isCurrentFormExist)

        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering(false);
        }
    };



    const getAllEmp_code = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/ourcompanyempdetails/${active}/${toggleCompany}/`);
            const sortedList = customSortByKey(res.data, "emp_code");
            setEmpList(sortedList);
        } catch (err) {
            //toast Logic
            handleErrorToast(err)
        } finally {
            setBuffering1(false);// End Buffering
        }
    };

    const getTaxRegimeList = async (companyId) => {
        setBuffering2(true);
        if (!companyId || companyId === "null") {
            setTaxRegimeData([]);
            return;
        }
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${companyId}/`);
            setTaxRegimeData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering2(false)
        }
    };



    useEffect(() => {
        getUserInvestmentDetails();
    }, [declarationStatus, proofStatus, division])

    useEffect(() => {
        getAllEmp_code();
        getTaxRegimeList(toggleCompany);
    }, [toggleCompany])

    const options = empList
        .sort((a, b) => a.emp_code - b.emp_code)
        .map((i) => ({
            value: i.emp_code,
            label: `${i.emp_code} - ${i.name}`,
        }));
    const nullOption = { value: 'null', label: 'Select Employee Code' };

    const handleChange = (selectedOption) => {
        if (selectedOption) {
            setEmployee(selectedOption.value);
        } else {
            setEmployee('null');
        }
    };

    const handleSearch = () => {
        let filtered = [...investmentFormData];


        if (searchQuery) {
            const lowercaseQuery = searchQuery.toLowerCase().trim();

            filtered = filtered.filter((n) => {
                const empCodeMatch = String(n.emp_code ?? "")
                    .toLowerCase()
                    .includes(lowercaseQuery);

                const empNameMatch = String(n.emp_name ?? "")
                    .toLowerCase()
                    .includes(lowercaseQuery);

                const regimeMatch = String(n.regime_details?.name ?? "")
                    .toLowerCase()
                    .includes(lowercaseQuery);

                return empCodeMatch || empNameMatch || regimeMatch;
            });
        }


        if (employee && employee !== "null") {
            filtered = filtered.filter(
                (n) => String(n.emp_code) === String(employee)
            );
        }


        if (regimeList) {
            filtered = filtered.filter(
                (n) => String(n.regime) === String(regimeList)
            );
        }


        if (declarationFilter) {
            filtered = filtered.filter(
                (n) => n.declaration_status === declarationFilter
            );
        }


        if (proofFilter) {
            filtered = filtered.filter(
                (n) => n.proofs_status === proofFilter
            );
        }

        setFilteredData(filtered);
    };





    const openProofModal = (proofs = []) => {
        console.log(proofs, "proofs");

        setSelectedProofs(proofs || []);
        setViewProof(true);
    };

    const openUploadModal = (row) => {
        setSelectedItem(row);
        setUploadProof(true);
    };

    useEffect(() => {
        handleSearch();
    }, [
        searchQuery,
        investmentFormData,
        declarationFilter,
        proofFilter,
        employee,
        regimeList,
    ]);




    return (
        <div className="content-tabs" style={{margin:"0"}}>
            {viewAccess === 'hr' ? (
                <div className="field-parent-cont">
                    <div className="field-cont">
                        {SUPER_ADMIN &&
                            <>
                                <div className="field-cont-div">
                                    <select
                                        onChange={(e) => setToggleCompany(e.target.value)}
                                        value={toggleCompany}
                                        className="attendance-input-field width-10vw   date-field"
                                    >
                                        <option value="">Select Sub Company</option>
                                        {SUB_COMPANIES.map(company => (
                                            <option key={company.id} value={company.id}>
                                                {company.title}
                                            </option>
                                        ))}
                                    </select>
                                    <hr className="field-cont-hr" />
                                </div>
                            </>
                        }

                        <div className="field-cont-div">
                            <Active />
                            <select
                                className="attendance-input-field width-10vw  "
                                type="text"
                                value={active}
                                onChange={(e) => {
                                    setActive(e.target.value)
                                }}
                            >
                                <option value="null">All</option>
                                <option value="active">Active</option>
                                <option value="inactive">In Active</option>
                            </select>
                            <hr className="field-cont-hr" />
                        </div>

                        <div className="field-cont-div">
                            <>
                                {buffer1 ?
                                    <div className="spinner-vsmall"></div>
                                    :
                                    <Employee />
                                }
                                <Select
                                    className="attendance-input-field width-20vw"
                                    options={[nullOption, ...options]}
                                    value={options.find(option => option.value === employee) || nullOption}
                                    placeholder="Select Employee Code"
                                    onChange={handleChange}
                                    isClearable
                                    styles={CSSForDropdownFilter2}
                                />
                            </>
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <div className="table-searchh color-badge-white">
                                <div className="field-cont-div">
                                    {buffer2 ? <div className="spinner-vsmall"></div> : <Filter />}

                                    <select
                                        className="attendance-input-field width-25vw date-field"
                                        value={regimeList}
                                        onChange={(e) => setTaxRegimeList(e.target.value)}
                                    >
                                        <option value="">Select Tax Regime</option>
                                        {taxRegimeData.map((i) => (
                                            <option value={i.id}>
                                                {i.name} ({formattedDateLong(i.financial_year_start)} - {formattedDateLong(i.financial_year_end)})
                                            </option>
                                        ))}
                                    </select>

                                </div>

                            </div>
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-15vw"
                                value={declarationFilter}
                                onChange={(e) => setDeclarationFilter(e.target.value)}
                            >
                                <option value="">Declaration Status</option>
                                <option value="approved">Approved</option>
                                <option value="submitted">Submitted</option>
                                <option value="rejected">Rejected</option>
                                <option value="draft">Draft</option>
                            </select>
                            <hr className="field-cont-hr" />
                        </div>

                        <div className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw"
                                value={proofFilter}
                                onChange={(e) => setProofFilter(e.target.value)}
                            >
                                <option value="">Proof Status</option>
                                <option value="approved">Approved</option>
                                <option value="submitted">Submitted</option>
                                <option value="rejected">Rejected</option>
                                <option value="draft">Draft</option>
                            </select>
                            <hr className="field-cont-hr" />
                        </div>


                    </div>
                    <div className="btn-cont" style={{ minWidth: '200px' }}>
                        <AddEmpInvestmentForm emp_code={emp_code} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} PERMISSION_HR_ADMIN={PERMISSION_HR_ADMIN} getInvestmentForm={getUserInvestmentDetails} currentFormExists={currentFormExists} viewAccess={viewAccess} />
                    </div>
                </div>
            )
                : (
                    ''
                )
            }
            <div className="table-css-white-background">
                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500 font-size-heading">Investment Form</div>

                    {viewAccess !== 'hr' && (<div className="field-cont">
                        <AddEmpInvestmentForm emp_code={emp_code} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} PERMISSION_HR_ADMIN={PERMISSION_HR_ADMIN} getInvestmentForm={getUserInvestmentDetails} currentFormExists={currentFormExists} viewAccess={viewAccess} />
                    </div>
                    )}
                </div>
                <div className="table-css-white-background scroll-container-table">
                    {/* <div className="table-heading-flex">
                    <div className="repo-heading font-weight500 font-size-heading">Stage of Bank Details Change</div>
                </div> */}
                    <table className="table-css">
                        <thead className="table-heading stciky-heading-top">
                            <tr className="custom-table-head-tr">
                                <th className="align-left">S.No</th>
                                {PERMISSION_HR_ADMIN && <th className="align-left">Employee</th>}
                                {toggleCompany === "null" && <th className="align-center">Subcompany</th>}

                                <th className="align-center">Tax Regime</th>
                                <th className="align-center">Status</th>

                                <th className="align-center">Investment Detail</th>
                                <th className="align-center">Declaration Status</th>
                                <th className="align-center">Declaration Remarks</th>
                                <th className="align-center">Proof Status</th>
                                <th className="align-center">Proof Remarks</th>
                                <th className="align-center">Created At</th>
                                <th className="align-center">Last Update</th>
                                <th className="align-center">Action</th>
                            </tr>
                        </thead>


                        {buffer ? <div className="spinner"></div> :

                            <tbody>
                                {filteredData.length === 0 ? (
                                    <tr>
                                        <td colSpan={16} className="align-center text-gray-500">
                                            No Investement records found
                                        </td>
                                    </tr>
                                ) : (
                                    [...filteredData]
                                        .sort((a, b) => {
                                            const yearA = new Date(a?.regime_details?.financial_year_start);
                                            const yearB = new Date(b?.regime_details?.financial_year_start);
                                            return yearB - yearA;
                                        })
                                        .map((i, index) => {
                                            const today = new Date();
                                            const start = new Date(i.regime_details.proof_submission_start_date);
                                            const end = new Date(i.regime_details.proof_submission_end_date);
                                            const isProofWindowOpen = today >= start && today <= end;

                                            console.log(isProofWindowOpen, "iswindow");

                                            return (

                                                <React.Fragment key={index}>
                                                    <tr className="tr-border-bottom">
                                                        <td colSpan="6"></td>
                                                    </tr>
                                                    <tr className="custom-table-head-td">
                                                        <td className="align-left">{index + 1}</td>
                                                        {PERMISSION_HR_ADMIN && (
                                                            <td className="align-center">
                                                                <CustomImageModal customStyle>
                                                                    {i.emp_profilepic ? (
                                                                        <img
                                                                            src={`${`${IMAGE_URL}${i.emp_profilepic}`}`}
                                                                            alt={`${i.emp_name}`} className="profile-img"
                                                                        />
                                                                    ) : (
                                                                        <UserDefaultLogo user={{ name: i.emp_name, profilepic: i.emp_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                                    )}
                                                                </CustomImageModal>
                                                                <p>{i.emp_code}-{i.emp_name}</p>
                                                            </td>
                                                        )}

                                                        <td
                                                            className="align-center width-5vw"
                                                            title={`${formatDate(i?.regime_details?.financial_year_start)} to ${formatDate(i?.regime_details?.financial_year_end)}`}
                                                            style={{ cursor: 'help' }}
                                                        >
                                                            {i?.regime_details?.name} ({formatDate(i?.regime_details?.financial_year_start, true).MonthYear} to {formatDate(i?.regime_details?.financial_year_end, true).MonthYear})
                                                        </td>
                                                        <td className="table-body width-15vw align-center">
                                                            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="table-body">Declaration Status</td>
                                                                        <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                                        <td
                                                                            request-status={i.declaration_status}
                                                                            className="align-center request-status text-capitalize word-wrap-20vw"
                                                                        >
                                                                            {i.declaration_status}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="table-body">Proof Verification Status</td>
                                                                        <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                                        <td
                                                                            request-status={i.proofs_status}
                                                                            className="align-center request-status text-capitalize word-wrap-20vw"
                                                                        >
                                                                            {i.proofs_status}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>




                                                        <td className="align-center">
                                                            {i?.items && i?.items.length > 0 ? (

                                                                <>
                                                                    <CustomShowTableData
                                                                        title="Investment Details"
                                                                        buttonLabel="View"
                                                                        data={i.items}
                                                                        layout="horizontal"
                                                                        columns={[
                                                                            { header: "Regime", accessor: "items_details.regime_name" },
                                                                            { header: "Section", accessor: "items_details.section_name" },
                                                                            { header: "Item Type", accessor: "items_details.item_type" },
                                                                            { header: "Declared Amount", accessor: "declared_amount", render: (v) => v ? Number(v).toLocaleString() : "-" },
                                                                            { header: "Final Amount", accessor: "final_amount", render: (v) => v ? Number(v).toLocaleString() : "-" },
                                                                            {
                                                                                header: "Declaration Status", accessor: "declaration_status", render: (v) => (
                                                                                    <span className="request-status text-capitalize" request-status={v}>
                                                                                        {v}
                                                                                    </span>
                                                                                )
                                                                            },
                                                                            { header: "Proof Amount", accessor: "calculation_amount", render: (v) => v ? Number(v).toLocaleString() : "-" },
                                                                            // { header: "Proof Calculation", accessor: "final_amount", render: (v) => v ? Number(v).toLocaleString() : "-" },
                                                                            {
                                                                                header: "Proof Verification Status", accessor: "proof_status", render: (v) => (
                                                                                    <span className="request-status text-capitalize" request-status={v}>
                                                                                        {v}
                                                                                    </span>
                                                                                )
                                                                            },
                                                                        ]}
                                                                        actions={[
                                                                            {

                                                                                label: (
                                                                                    <button
                                                                                        className="text-button allproject-dashboard"
                                                                                    >
                                                                                        <BlueEye /> View
                                                                                    </button>
                                                                                ),
                                                                                show: (row) => row.proofs?.length > 0,
                                                                                onClick: (row) => {
                                                                                    setSelectedProofs(row.proofs);

                                                                                    setCalculationProofData({
                                                                                        calculation_amount: row.calculation_amount,
                                                                                        calculation_remarks: row.calculation_remarks,
                                                                                        calculation_attachment: row.calculation_attachment,
                                                                                    });

                                                                                    setViewProof(true);
                                                                                },

                                                                            },

                                                                        ]}
                                                                    />

                                                                    <ProofViewModal show={viewProof} onClose={() => setViewProof(false)} proofs={selectedProofs} calculationProofsData={calculationProofData} />

                                                                    {/* <ProofUploadModal
                                                            show={uploadProof}
                                                            onClose={() => setUploadProof(false)}
                                                            item={selectedItem}
                                                            itemParent={i}
                                                            getInvestmentForm={getUserInvestmentDetails}
                                                        // refresh={() => getUserInvestmentDetails?.()}
                                                        /> */}
                                                                </>
                                                            ) : (
                                                                "-"
                                                            )}
                                                        </td>

                                                        <>
                                                            <ViewDynamicApprovalStatus dynamic_approval={i.declaration_dynamic_approval} />
                                                            <ViewDynamicApprovalRemarks dynamic_approval={i.declaration_dynamic_approval} />
                                                        </>

                                                        <>
                                                            <ViewDynamicApprovalStatus dynamic_approval={i.proof_dynamic_approval} />
                                                            <ViewDynamicApprovalRemarks dynamic_approval={i.proof_dynamic_approval} />
                                                        </>




                                                        <td className="table-body align-center">
                                                            {i.created_at === i.updated_at ? (
                                                                <UserProfileModal
                                                                    code={i.updated_by && i.emp_code !== i.updated_by ? i.updated_by : i.emp_code}
                                                                    name={i.updated_by && i.emp_code !== i.updated_by ? i.updated_by_name : i.emp_name}
                                                                    profilePic={
                                                                        i.updated_by && i.emp_code !== i.updated_by
                                                                            ? i.updated_by_profilepic
                                                                            : i.emp_profilepic
                                                                    }
                                                                    dateText={formatDateTime(i.created_at).shortfull}
                                                                />
                                                            ) : (
                                                                <>
                                                                    {formatDateTime(i.created_at).longdate}
                                                                    <br />
                                                                    <small>{formatDateTime(i.created_at).time}</small>
                                                                </>
                                                            )}
                                                        </td>

                                                        <td className="table-body align-center">

                                                            {i.updated_by ? (
                                                                <UserProfileModal
                                                                    code={i.updated_by}
                                                                    name={i.updated_by_name}
                                                                    profilePic={i.updated_by_profilepic}
                                                                    dateText={formatDateTime(i.updated_at).shortfull}
                                                                />
                                                            ) : (
                                                                <>
                                                                    {formatDateTime(i.updated_at).longdate}
                                                                    <br />
                                                                    <small>{formatDateTime(i.updated_at).time}</small>
                                                                </>
                                                            )}
                                                        </td>




                                                        <td className="align-center width-5vw" >
                                                            <div className="flex-row justify-between">
                                                                {/* --------------------------------------------incomplete */}
                                                                {(i.declaration_status === 'draft' || (isProofWindowOpen && (i.proofs_status === 'draft' || i.proofs_status === 'rejected'))) && (
                                                                    <UpdateEmpInvestmentForm1
                                                                        i={i}
                                                                        SUB_COMPANIES={SUB_COMPANIES}
                                                                        SUPER_ADMIN={SUPER_ADMIN}
                                                                        PERMISSION_HR_ADMIN={PERMISSION_HR_ADMIN}
                                                                        getInvestmentForm={getUserInvestmentDetails}
                                                                    />
                                                                )}

                                                                {i.declaration_status === 'draft' && (
                                                                    <SubmitInvestmentDeclaration
                                                                        i={i}
                                                                        getInvestmentForm={getUserInvestmentDetails}
                                                                    />
                                                                )}

                                                                {(i.declaration_status === 'rejected' && i.proofs_status === 'draft') && (
                                                                    <ResubmitInvestmentDeclaration
                                                                        i={i}
                                                                        getInvestmentForm={getUserInvestmentDetails}
                                                                    />
                                                                )}


                                                                {i.declaration_dynamic_approval?.length > 0 &&
                                                                    Array.isArray(i.declaration_dynamic_approval) &&
                                                                    i.declaration_dynamic_approval.every(
                                                                        (approval) => approval.approval_status === "approved"
                                                                    ) &&
                                                                    i.declaration_status === 'approved' &&
                                                                    (i.proofs_status === 'draft') && isProofWindowOpen && (
                                                                        <SubmitInvestmentProofs
                                                                            i={i}
                                                                            getInvestmentForm={getUserInvestmentDetails}
                                                                        />
                                                                    )}

                                                                {i.proofs_status === 'rejected' && (
                                                                    <ResubmitInvestmentProof
                                                                        i={i}
                                                                        getInvestmentForm={getUserInvestmentDetails}
                                                                    />
                                                                )}

                                                                {
                                                                    (i.declaration_status === 'rejected' ||
                                                                        (i.declaration_status === 'draft' && i.proofs_status === 'draft')) && (
                                                                        <DeleteInvestmentForm i={i} getInvestmentForm={getUserInvestmentDetails}
                                                                        />)}
                                                                {/* <DeleteInvestmentForm i={i} getInvestmentForm={getUserInvestmentDetails} /> */}

                                                            </div>
                                                        </td>
                                                    </tr>

                                                </React.Fragment>
                                            )
                                        })
                                )
                                }

                            </tbody>
                        }

                    </table>
                </div >
                <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            </div>
        </div>
    );
};


export {
    TaxRegimeTable,
    InvestmentTypesTable,
    TaxSectionTable,
    AgeRangeForTaxSlabTable,
    TaxSlabTable,
    SurchargeSlabTable,
    InvestmentDeclarationFormTable,
};
